// Verified against the Fairmints Rare Pepe catalogue on 2026-09-09.
// Image URLs point to the original card art; no portraits are generated here.
export default {
  "PEPECASH": {
    "asset": "PEPECASH", "series": 1, "card": 11,
    "artist": "Mike", "image_url": "https://cdn.xcp.io/img/full/PEPECASH"
  },
  "PEPETOWN": {
    "asset": "PEPETOWN", "series": 15, "card": 6,
    "artist": "BuddhaAF", "image_url": "https://cdn.xcp.io/img/full/PEPETOWN"
  },
  "PEPEJOINTSPH": {
    "asset": "PEPEJOINTSPH", "series": 1, "card": 13,
    "artist": "John Villar", "image_url": "https://cdn.xcp.io/img/full/PEPEJOINTSPH"
  },
  "PEPEOMUERTE": {
    "asset": "PEPEOMUERTE", "series": 18, "card": 6,
    "artist": "RarePepeNews", "image_url": "https://cdn.xcp.io/img/full/PEPEOMUERTE"
  },
  "RAREPEPE": {
    "asset": "RAREPEPE",
    "series": 1,
    "card": 1,
    "artist": "Mike",
    "image_url": "https://cdn.xcp.io/img/full/RAREPEPE"
  },
  "PEPEKEEPER": {
    "asset": "PEPEKEEPER",
    "series": 17,
    "card": 32,
    "artist": "Hosherama",
    "image_url": "https://cdn.xcp.io/img/full/PEPEKEEPER"
  },
  "FSBPUTINPEPE": {
    "asset": "FSBPUTINPEPE",
    "series": 3,
    "card": 18,
    "artist": "DanDarkPill",
    "image_url": "https://cdn.xcp.io/img/full/FSBPUTINPEPE"
  },
  "DANKPEPE": {
    "asset": "DANKPEPE",
    "series": 1,
    "card": 5,
    "artist": "Shawn Leary",
    "image_url": "https://cdn.xcp.io/img/full/DANKPEPE"
  },
  "FROGBUS": {
    "asset": "FROGBUS",
    "series": 28,
    "card": 34,
    "artist": "Easy B",
    "image_url": "https://cdn.xcp.io/img/full/FROGBUS"
  },
  "JIHANWU": {
    "asset": "JIHANWU",
    "series": 20,
    "card": 8,
    "artist": "Indelible",
    "image_url": "https://cdn.xcp.io/img/full/JIHANWU"
  },
  "BLAINEPEPE": {
    "asset": "BLAINEPEPE",
    "series": 10,
    "card": 33,
    "artist": "Mr Hansel",
    "image_url": "https://cdn.xcp.io/img/full/BLAINEPEPE"
  },
  "LORDKEK": {
    "asset": "LORDKEK",
    "series": 1,
    "card": 34,
    "artist": "Kek",
    "image_url": "https://cdn.xcp.io/img/full/LORDKEK"
  },
  "HOODEDPEPE": {
    "asset": "HOODEDPEPE",
    "series": 32,
    "card": 50,
    "artist": "1L1RHscpBDj3PvDnFLW6KLTXkDm5EMNHBQ",
    "image_url": "https://cdn.xcp.io/img/full/HOODEDPEPE"
  },
  "HAIRPEPE": {
    "asset": "HAIRPEPE",
    "series": 1,
    "card": 18,
    "artist": "Hairpepe",
    "image_url": "https://cdn.xcp.io/img/full/HAIRPEPE"
  },
  "PEPEMINING": {
    "asset": "PEPEMINING",
    "series": 1,
    "card": 46,
    "artist": "Hcarpach",
    "image_url": "https://cdn.xcp.io/img/full/PEPEMINING"
  },
  "PEAKYPEPE": {
    "asset": "PEAKYPEPE",
    "series": 25,
    "card": 20,
    "artist": "RAR3HANDS",
    "image_url": "https://cdn.xcp.io/img/full/PEAKYPEPE"
  },
  "PEPESMALLS": {
    "asset": "PEPESMALLS",
    "series": 11,
    "card": 36,
    "artist": "18CWner9AeXoXNGiZogrz4igj8c8u4G9aC",
    "image_url": "https://cdn.xcp.io/img/full/PEPESMALLS"
  },
  "RADIOPEPE": {
    "asset": "RADIOPEPE",
    "series": 9,
    "card": 48,
    "artist": "17RZu6GxzjU5dQqvsNDPifjNrKZSDnBGE8",
    "image_url": "https://cdn.xcp.io/img/full/RADIOPEPE"
  },
  "MODERNPEPE": {
    "asset": "MODERNPEPE",
    "series": 17,
    "card": 43,
    "artist": "Meme Conscious",
    "image_url": "https://cdn.xcp.io/img/full/MODERNPEPE"
  },
  "PEPEBASQUIAT": {
    "asset": "PEPEBASQUIAT",
    "series": 16,
    "card": 24,
    "artist": "Luca",
    "image_url": "https://cdn.xcp.io/img/full/PEPEBASQUIAT"
  },
  "PEPENOPOULOS": {
    "asset": "PEPENOPOULOS",
    "series": 3,
    "card": 25,
    "artist": "0jak",
    "image_url": "https://cdn.xcp.io/img/full/PEPENOPOULOS"
  },
  "RARELORDKEK": {
    "asset": "RARELORDKEK",
    "series": 17,
    "card": 3,
    "artist": "ICQPEPE",
    "image_url": "https://cdn.xcp.io/img/full/RARELORDKEK"
  },
  "MELANCHOLIA": {
    "asset": "MELANCHOLIA",
    "series": 18,
    "card": 39,
    "artist": "Deleted account",
    "image_url": "https://cdn.xcp.io/img/full/MELANCHOLIA"
  },
  "PEPLACERESLT": {
    "asset": "PEPLACERESLT",
    "series": 30,
    "card": 49,
    "artist": "13vEW6M4wjEVF52Ymc92QKt7N6aZcXMFiR",
    "image_url": "https://cdn.xcp.io/img/full/PEPLACERESLT"
  },
  "DJPEPE": {
    "asset": "DJPEPE",
    "series": 4,
    "card": 29,
    "artist": "Rare Scrilla",
    "image_url": "https://cdn.xcp.io/img/full/DJPEPE"
  },
  "HOMERPEPE": {
    "asset": "HOMERPEPE",
    "series": 2,
    "card": 32,
    "artist": "Boost",
    "image_url": "https://cdn.xcp.io/img/full/HOMERPEPE"
  },
  "PEPEPARTY": {
    "asset": "PEPEPARTY",
    "series": 1,
    "card": 7,
    "artist": "Looney",
    "image_url": "https://cdn.xcp.io/img/full/PEPEPARTY"
  },
  "REDPUTINPEPE": {
    "asset": "REDPUTINPEPE",
    "series": 3,
    "card": 20,
    "artist": "DanDarkPill",
    "image_url": "https://cdn.xcp.io/img/full/REDPUTINPEPE"
  },
  "PEPMONDRIAN": {
    "asset": "PEPMONDRIAN",
    "series": 22,
    "card": 24,
    "artist": "Luca",
    "image_url": "https://cdn.xcp.io/img/full/PEPMONDRIAN"
  }
};
